var CurrentUser = require("lib/account/CurrentUser");
var Redirect = require('react-router-dom').Redirect;

function getWrapperComponent(baseComponent, permissions) {
	function checkPermissions() {
		if (permissions.allAccess) {
			return true;
		}

		if (permissions.developmentAccess && $wr.isDevelopment()) {
			return true;
		}

		if (permissions.loggedOut && !CurrentUser.isLoaded()) {
			return true;
		}
		if (permissions.loggedIn && CurrentUser.isLoaded()) {
			return true;
		}

		if (permissions.students && CurrentUser.isStudent()) {
			return true;
		}
		if (permissions.wizards && CurrentUser.isWizard()) {
			return true;
		}
		if (permissions.teachers && CurrentUser.isTeacherAdmin()) {
			return true;
		}
		if (permissions.allAdmins && CurrentUser.isAdmin()) {
			return true;
		}

		if (permissions.passcodes && CurrentUser.isPassphraseUser()) {
			return true;
		}

		return false;
	}

	return function(props) {
		if (checkPermissions()) {
			return React.createElement(baseComponent, props);
		} else {
			var redirectPath = CurrentUser.isLoaded() ? "/" : "/login";
			return (
				<Redirect to={ redirectPath } />
			);
		}
	}
}

module.exports = {
	Students: function(baseComponent) {
		return getWrapperComponent(baseComponent, { students: true });
	},
	Teachers: function(baseComponent) {
		return getWrapperComponent(baseComponent, { teachers: true });
	},
	Wizards: function(baseComponent) {
		return getWrapperComponent(baseComponent, { wizards: true });
	},
	TeachersAndSchoolAdmins: function(baseComponent) {
		return getWrapperComponent(baseComponent, { allAdmins: true });
	},
	LoggedIn: function(baseComponent) {
		return getWrapperComponent(baseComponent, { loggedIn: true });
	},
	LoggedOut: function(baseComponent) {
		return getWrapperComponent(baseComponent, { loggedOut: true });
	},
	Passcodes: function(baseComponent) {
		return getWrapperComponent(baseComponent, { passcodes: true });
	},
	AllAccess: function(baseComponent) {
		return getWrapperComponent(baseComponent, { allAccess: true });
	},
	DevelopmentAccess: function(baseComponent) {
		return getWrapperComponent(baseComponent, { developmentAccess: true });
	},
};



// WEBPACK FOOTER //
// ./modules/lib/technical/RouteAuth.js